import { useAuth } from '../contexts/AuthContext';
import { useContentAdmin } from './useContentAdmin';

export function useIsAdmin() {
  const { isAdmin, loading } = useAuth();
  const { isContentAdmin } = useContentAdmin();

  return {
    isAdmin: isAdmin || isContentAdmin,
    loading,
  };
}
